import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useStyles } from "../../assets/jss/views/Auth";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomTextField from "../CustomComponents/CustomTextField/CustomTextField";
import CustomButton from "../CustomComponents/CustomButton/CustomButton";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { doForgotPassword } from "../../services/ForgottenPassword";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ForgotPassword(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState("");
  const [emailSentSuccessfully, setEmailSentSuccessfully] = useState(null);
  const [emailSentMessage, setEmailSentMessage] = useState(null);
  const [email, setEmail] = useState("");
  const [emailPattern] = useState(
    "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$"
  );
  const [loading, setLoading] = useState(false);
  const [isEmailInvalid, setIsEmailInvalid] = useState(false);
  const [isEmail, setIsEmail] = useState(null);

  useEffect(() => {
    if (props.errorMessage && props.errorMessage.length) {
      setErrorMessage(props.errorMessage);
    }
  }, [props.errorMessage]);

  async function loadData(email) {
    const data = await doForgotPassword(email);
    if (data && data.status && data.status.message) {
      setEmailSentMessage(data.status.message);
    }
    if (
      data &&
      (data.status.code === 0 ||
        data.status.code === 200 ||
        data.status.code === 201)
    ) {
      setEmailSentSuccessfully(true);
      setIsEmailInvalid(false);
      setLoading(false);
      setTimeout(function () {
        history.push("/login");
      }, 1500);
    } else {
      setEmailSentSuccessfully(false);
      setIsEmailInvalid(false);
      setLoading(false);
    }
  }
  const handleFormSubmit = () => {
    setLoading(true);
    setErrorMessage(null);
    setIsEmailInvalid(false);
    setEmailSentSuccessfully(null);
    props.resetKeyDown(false);
    if (email === null || email.length === 0) {
      setIsEmail(false);
      setLoading(false);
      return;
    } else if (email !== null && email.length > 0) {
      setIsEmail(true);
    }
    if (
      email !== null &&
      email.length > 0 &&
      email.trim().match(emailPattern) === null
    ) {
      setIsEmailInvalid(true);
      setLoading(false);
      return;
    }

    loadData(email.trim());
  };

  useEffect(() => {
    if (props.handleKeyDown) {
      handleFormSubmit();
    }
  }, [props.handleKeyDown]);

  return (
    <form>
      <CustomBox className={classes.boxWrapper}>
        <CustomBox
          className={clsx(classes.titleWrap, classes.titleWrapForgotten)}
        >
          <CustomTypography
            component="h1"
            variant="h5"
            className={classes.title}
          >
            {t("FORGOT_PASSWORD")}
          </CustomTypography>
          {isEmail === false && (
            <CustomTypography
              component="p"
              className={clsx(
                classes.errorMessage,
                classes.errorMessageForgotten
              )}
            >
              {t("PLEASE_ENTER_YOUR_EMAIL_ADDRESS_AND_TRY_AGAIN")}
            </CustomTypography>
          )}
          {errorMessage && errorMessage.length ? (
            <CustomTypography
              component="p"
              className={clsx(
                classes.errorMessage,
                classes.errorMessageForgotten
              )}
            >
              {errorMessage}
            </CustomTypography>
          ) : null}
          {isEmailInvalid === true && (
            <CustomTypography
              component="p"
              className={clsx(
                classes.errorMessage,
                classes.errorMessageForgotten
              )}
            >
              {t(
                "LOOKS_LIKE_YOU_HAVE_ENTERED_AN_INVALID_EMAIL_ADDRESS_PLEASE_UPDATE_YOUR_EMAIL_ADDRESS_AND_TRY_AGAIN"
              )}
            </CustomTypography>
          )}
          {emailSentSuccessfully === true && (
            <CustomTypography component="p" className={classes.successMessage}>
              {emailSentMessage
                ? emailSentMessage
                : t("EMAIL_SUBMITTED_SUCCESSFULLY")}
            </CustomTypography>
          )}
          {emailSentSuccessfully === false && (
            <CustomTypography
              component="p"
              className={clsx(
                classes.errorMessage,
                classes.errorMessageForgotten
              )}
            >
              {emailSentMessage
                ? emailSentMessage
                : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`}
            </CustomTypography>
          )}
        </CustomBox>
        <CustomBox my={4}>
          <CustomTextField
            className={classes.input}
            label={t("EMAIL")}
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{ disableUnderline: true }}
          />
        </CustomBox>
        <CustomBox mt={4} mb={3}>
          <CustomButton
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleFormSubmit}
          >
            {t("SUBMIT")}
            {loading && (
              <CustomCircularProgress
                color="inherit"
                style={{ marginLeft: "15px" }}
                size={15}
              />
            )}
          </CustomButton>
        </CustomBox>
      </CustomBox>
    </form>
  );
}
